import { object, string, ref } from 'yup';
import { isEmpty } from 'lodash';

export const SignupArtistGenresSchema = object().shape({
  primaryGenre: string().label('Primary genre').trim(),
  secondaryGenre: string().label('Secondary genre').trim()
    .when('primaryGenre', {
      is: (value) => !isEmpty(value),
      then: (schema) => schema.notOneOf([ref('primaryGenre')], 'Choose a genre that\'s different from your primary genre'),
    }),
});
